import Auth from '@/mixins/auth.js'
import AppData from '@/mixins/appdata.js'
import OfflineModal from '@/components/common/OfflineModal.vue'
import LoadingModal from '@/components/common/LoadingModal.vue'
import ConfirmDialog from '@/components/common/ConfirmDialog.vue'
import isDesktopApp from '@/desktop-app/isDesktopApp.js'
import desktopApp from '@/desktop-app/desktopApp.js'
import ipcCommandsEnum from '@/desktop-app/ipcCommandsEnum.js'
import {stopCloudUpdatePollingCheck} from '@/api/ApiUpdate.js'

export default {
  components: {
    OfflineModal,
    LoadingModal,
    ConfirmDialog
  },

  mixins: [AppData, Auth],

  data() {
    return {
      confirmDialogLogOutVisible : false,
      confirmDialogExitAppVisible: false,
      offlineModalVisible        : false,
      showLoader                 : false,
      showLoaderTitle            : ''
    }
  },

  created() {
    console.log('appConfig::', this.appConfig)
    console.log(`%c${'-'.repeat(15)} APP CREATED ${this.appVersion} (${this.$options.name}) ${this.appConfig?.LOCATION_DATA.SiteUrl} ${'-'.repeat(15)}`, 'background-color: #388E3C; color: #A5D6A7; padding: 10px 10px;')

    this.$bus.$on('show-app-loading-modal', this.showLoadingModal)
    this.$bus.$on('show-app-offline-modal', this.showOfflineModal)
    this.$bus.$on('hide-app-offline-modal', this.hideOfflineModal)
    this.$bus.$on('app-show-notification', this.showNotification)
    this.$bus.$on('app-logout', this.appLogout)

    if (isDesktopApp()) {
      const desktopBridge = desktopApp()
      desktopBridge.on(ipcCommandsEnum.AppExit, () => {
        this.onAppExit()
      })
    }
  },

  beforeDestroy() {
    console.log('%c--------------- APP DESTROYED ---------------', 'background-color: #E53935; color: #EF9A9A; padding: 10px 10px;')

    this.$bus.$off('show-app-loading-modal', this.showLoadingModal)
    this.$bus.$off('show-app-offline-modal', this.showOfflineModal)
    this.$bus.$off('hide-app-offline-modal', this.hideOfflineModal)
    this.$bus.$off('app-show-notification', this.showNotification)
    this.$bus.$off('app-logout', this.appLogout)
  },

  methods: {
    onAppExit() {
      this.navigationDrawer = false
      this.confirmDialogExitAppVisible = true
    },

    onExitAppYes() {
      this.$bus.$emit('app-logout')
      if (isDesktopApp()) {
        const desktopBridge = desktopApp()
        desktopBridge.send(ipcCommandsEnum.AppExit)
      }
    },

    showLoadingModal(showModal = true, title = '') {
      this.showLoader = showModal
      this.showLoaderTitle = title || ''
    },

    showOfflineModal() {
      window.offlineModalVisible = true
      this.offlineModalVisible = true
    },
    hideOfflineModal() {
      window.offlineModalVisible = false
      this.offlineModalVisible = false
    },

    showLogOutDialog() {
      this.confirmDialogLogOutVisible = true
    },
    onLogOutYes() {
      this.$bus.$emit('app-logout')
    },
    appLogout(resetApp = false) {
      if (this.$router.currentRoute.name === 'Pos') {
        this.$bus.$emit('app-logout-from-pos-screen')
        setTimeout(() => {
          if (resetApp) {
            this.resetApp()
          } else {
            this.logout()
          }
        }, 350)
        return
      }
      if (resetApp) {
        this.resetApp()
      } else {
        this.logout()
      }
    },
    logout() {
      window.API.post(window.APICall.logout, {})
        .catch(e => {
          console.error(e)
        })
        .finally(() => {
          this.resetApp()
        })
    },

    showNotification(data) {
      if (this.$route.name === 'Login') return

      this.$snotify[data.type](data.body, data.title, {
        timeout        : data.hasOwnProperty('timeout') ? data.timeout : 2500,
        showProgressBar: data.hasOwnProperty('showProgressBar') ? data.showProgressBar : true,
        closeOnClick   : data.hasOwnProperty('closeOnClick') ? data.closeOnClick : true,
        pauseOnHover   : data.hasOwnProperty('pauseOnHover') ? data.pauseOnHover : true,
        position       : data.position ? data.position : 'centerTop',
        buttons        : data.buttons ? data.buttons : [],
        icon           : data.icon ? data.icon : null,
        color          : data.color ? data.color : null,
        htmlBody       : data.htmlBody ? data.htmlBody : null
      })
    },

    resetApp() {
      this.$snotify.clear()
      this.PIN = ''
      this.pinCode = []
      this.posUser = null
      this.authorizationToken = ''
      window.staffName = ''
      window.authorizationToken = ''
      window.appConfig = null
      window.socketId = null
      this.$sessionStorage && this.$sessionStorage.clear()
      window.Socket && window.Socket.disconnect()
      stopCloudUpdatePollingCheck()
    }
  }
}
